import './FicheGeneriek.scss';
import { useEffect, useState } from "react";
import { MoreInfo } from "../../MoreInfo/MoreInfo";
import { Image } from '../../../Image/Image';
import { useMemo } from 'react';
import { FicheType } from '../../FicheType/FicheType';
export const FicheGeneriek = (props) => {
    const logoImageMode = "mode=max";
    let imageUrl = "";
    if (props.data.image && props.data.image.url) {
        if (!props.isLogoFiche) {
            imageUrl = props.data.image.url;
        }
        else {
            imageUrl = props.data.image.url.replace("mode=crop", logoImageMode);
        }
    };
    const bodyItems = useMemo(() => {
        let items = props.processFicheItems(props.data.body.items);
        return items;
    });

    return (
        <div
            className={` c-fiche c-generic-full ${props.data?.hasDetail ? "u-has-detail" : ""}`}
            onClick={() => {
                if (props.data?.hasDetail && props.openPopup) {
                    props.openPopup(props.data.urlSegment);
                }
            }}
            data-aos="fade-up"
        >
            <div>
                <FicheType type={props.data.type}>
                    <i class="fa-fw fa-fw fas fa-calendar-alt"></i>
                </FicheType>
                {props.data?.image?.url && (
                    <div className="image" title="Meer over">
                        <Image
                            alt={props.data.title}
                            src={imageUrl}
                        />
                    </div>
                )}
                <header className="c-fiche__header">
                    {props.data?.title &&
                        <h2 className="title" title={props.title}>
                            {props.data.title}
                        </h2>
                    }
                    {props.data?.text && props.data.text}
                </header>
                <div className="c-fiche__body">
                    <ul>{bodyItems}</ul>
                </div>
                <MoreInfo
                    data={props.data}
                    openPopup={props.openPopup}
                    cta={props.dictionary.moreInfo}
                />
            </div>
        </div>
    );
}